




























































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '../Icon.vue'

@Component({
  components: {
    Icon
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    strictValidation: {
      type: Boolean,
      default: false
    },
    matchValue: {
      type: String,
      default: ''
    },
    shouldMatch: {
      type: Boolean,
      default: false
    }
  }
})
export default class Input extends Vue {
  type: string = 'password'
  currentValue: string = ''
  validationDisplayVisible: boolean = false
  validatioProps: any = {
    lowerCase: false,
    upperCase: false,
    number: false,
    match: false,
    length: false
  }

  emitInput (e: any) {
    this.currentValue = e.target.value
    this.$emit('input', e.target.value)
    if (this.$props.strictValidation) {
      this.validate(e.target.value)
      this.$emit(
        'isValid',
        Object.keys(this.validatioProps).every(key => this.validatioProps[key])
      )
    }
  }

  emit (eventName: string, e: any) {
    this.currentValue = e.target.value
    this.$emit(eventName, e)
    if (this.$props.strictValidation) {
      this.validate(e.target.value)
    }
  }

  mounted () {
    this.currentValue = this.$props.value
    if (this.$props.strictValidation) {
      this.validate((this.$refs.password as any).value)
    }
  }

  validate (value: string) {
    this.validatioProps.lowerCase = /[a-z]+/.test(value)
    this.validatioProps.upperCase = /[A-Z]+/.test(value)
    this.validatioProps.number = /[0-9]+/.test(value)
    this.validatioProps.length = value.length >= 8
    this.validatioProps.match = !this.$props.shouldMatch ? true : !!(value && value === this.$props.matchValue)
  }

  showValidationDisplay () {
    if (this.$props.strictValidation) {
      this.validationDisplayVisible = true
    }
  }

  hideValidationDisplay () {
    this.validationDisplayVisible = false
  }

  toggleTextVisibility () {
    this.type = this.type === 'password'
      ? 'text'
      : 'password'
  }
}
